import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Loader } from 'Components';
import Select from 'react-virtualized-select';
import createFilterOptions from 'react-select-fast-filter-options';
import 'react-select/dist/react-select.css';
import 'react-virtualized-select/styles.css';
import './SelectVirtualField.css';

const SelectVirtualField = ({
  className,
  options,
  label,
  placeholder,
  required,
  isLoading,
  ...rest
}) => {
  const filterOptions = createFilterOptions({
    options,
  });

  const { disabled, value } = rest;
  const enableRequired = !disabled;

  return (
    <div className={`select-virtual-field ${className}`}>
      {label && (
        <div className="select-virtual-field__label">
          {label}
          {required && (
            <span className="select-virtual-field__required">*</span>
          )}{' '}
        </div>
      )}
      {isLoading && (
        <div className="select-field__loader">
          <Loader isSmall isSolidWhite />
        </div>
      )}
      {!isLoading && (
        <Fragment>
          <Select {...rest} options={options} filterOptions={filterOptions} />
          {enableRequired && (
            <input
              tabIndex={-1}
              autoComplete="off"
              className="select-virtual-field__manual__required"
              value={value}
              required={required}
            />
            )}
        </Fragment>
      )}
    </div>
  );
};

SelectVirtualField.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  isLoading: PropTypes.bool,
  className: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  })),
};

SelectVirtualField.defaultProps = {
  className: '',
  options: [],
};

export default SelectVirtualField;



// WEBPACK FOOTER //
// ./src/components/SelectVirtualField/SelectVirtualField.jsx